import React, { useState } from 'react'

export const Qwerty = ({alphabetKey, alphabet}) => {
    const [decipheredCode, setDecipheredCode] = useState('');

    const handleQwertyDecipher = (e) => {
        e.preventDefault()

        const code = e.target.qwerty_code.value.toLowerCase().toString()
        const shift = e.target.shift.value || ''
        const qwertyShift = 'qwertyuiopasdfghjklzxcvbnm'

        if (shift.length !== 26) {
            // Should set an error
            return
        }

        let codeKey = {}
        let decipheredCode = ''


        for(let i = 0; i < shift.length; i++) {
            codeKey[shift[i]] = qwertyShift[i]
        }

        for(let i in code) {
            const letter = code[i]

            if (/^[a-z]+$/.test(letter) === true) {
                let cipheredLetter = codeKey[letter]

                decipheredCode += cipheredLetter
            } else {
                decipheredCode += letter
            }
        }

        setDecipheredCode(decipheredCode)
    }

    return (
        <div>
            <h2>Qwerty Cypher</h2>
            <p>The Qwerty cipher is based on the position of the keyboard and letters. For example, "k lcvdce" translates to "a secret".
            This cypher also requires a shift key to be entered that is 26 characters long, which should be the mapping to overlay on
            a qwerty keyboard.</p>

            <p>Insert your coded message in the box, and the decoded message will be shown beneath it.</p>

            <form action="#" onSubmit={(e) => handleQwertyDecipher(e)}>
                <label htmlFor="shift" type="string">Shift Key</label>
                <br />
                <input name="shift" type="text" />
                <br />
                <label htmlFor="qwerty_code">EncodedMessage</label>
                <br />
                <input name="qwerty_code" type="text" />
                <button>Decode</button>
            </form>

            {decipheredCode !== '' && <p className="results">Result: {decipheredCode}</p> }
        </div>
    )
}